"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _TextEffect2 = _interopRequireDefault(require("./TextEffect"));

var _setContextTransform = _interopRequireDefault(require("../transform/setContextTransform"));

var _creative = require("../../../constants/creative");

var _models = require("../../../models");

var _text = require("../../../constants/text");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_INNER_SHADOW_VALUES = _text.DEFAULT_TEXT_EFFECTS_OBJECTS[_text.TEXT_EFFECTS.INNER_SHADOW];

var InnerShadowTextEffect = /*#__PURE__*/function (_TextEffect) {
  (0, _inherits2["default"])(InnerShadowTextEffect, _TextEffect);

  var _super = _createSuper(InnerShadowTextEffect);

  function InnerShadowTextEffect() {
    (0, _classCallCheck2["default"])(this, InnerShadowTextEffect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(InnerShadowTextEffect, null, [{
    key: "apply",
    value: function apply(finalContext, effectContext, frameNumber, contentFrameData, layerTransformData) {
      var textCanvas = finalContext.canvas;
      var textEffectCanvas = effectContext.canvas;
      var textRenderProperties = contentFrameData.textRenderProperties;
      this.drawTextLines(effectContext, contentFrameData);
      finalContext.setTransform(1, 0, 0, 1, 0, 0);
      finalContext.drawImage(textEffectCanvas, 0, 0, textEffectCanvas.width, textEffectCanvas.height);
      var fillColor = textRenderProperties.textEffect.get('color') || DEFAULT_INNER_SHADOW_VALUES.color; // invert alpha channel

      finalContext.globalCompositeOperation = _creative.CANVAS_COMPOSITE_OPERATIONS.XOR;
      finalContext.fillStyle = fillColor; // set color to shadow color

      finalContext.fillRect(0, 0, finalContext.canvas.width, finalContext.canvas.height); // draw text canvas on to itself again using drop-shadow filter

      finalContext.shadowColor = fillColor;
      finalContext.shadowBlur = textRenderProperties.textEffect.get('blur') / 10; // TODO figure out comparable values here (*4, /4)?

      finalContext.shadowOffsetX = textRenderProperties.textEffect.get('xOffset');
      finalContext.shadowOffsetY = textRenderProperties.textEffect.get('yOffset');
      finalContext.drawImage(textCanvas, 0, 0, textCanvas.width, textCanvas.height); // draw original image with background mixed on top

      finalContext.globalCompositeOperation = _creative.CANVAS_COMPOSITE_OPERATIONS.DESTINATION_ATOP;
      finalContext.shadowColor = _creative.TRANSPARENT_FILL_COLOR; // remove shadow !

      finalContext.drawImage(textEffectCanvas, 0, 0, textEffectCanvas.width, textEffectCanvas.height);
      finalContext.globalCompositeOperation = _creative.CANVAS_COMPOSITE_OPERATIONS.SOURCE_OVER; // reset composite operation
      // Set transform on text canvas, reset transform on final canvas.

      var rotation = layerTransformData.rotation,
          scaleX = layerTransformData.scaleX,
          scaleY = layerTransformData.scaleY,
          translationX = layerTransformData.translationX,
          translationY = layerTransformData.translationY;
      (0, _setContextTransform["default"])(finalContext, translationX, translationY, scaleX, scaleY, rotation, new _models.Rectangle(0, 0, textCanvas.width, textCanvas.height));
      var wrapWidth = textRenderProperties.wrapProperties.get('width');
      var wrapHeight = textRenderProperties.wrapProperties.get('height');
      finalContext.translate(-wrapWidth / 2, -wrapHeight / 2);
    }
  }]);
  return InnerShadowTextEffect;
}(_TextEffect2["default"]);

exports["default"] = InnerShadowTextEffect;